'use strict';

// Keep in sync with constants/colors.less
var Colors = {
  BLACK: '#000000',
  WHITE: '#ffffff',
  DARK: '#2e2f33',
  LIGHT: '#fff',
  GRAY_MID: '#797b80',
  GRAY_LIGHT: '#e8e8e8',
  GREEN: '#02cc7d',
  RED: '#fc3224',
  YELLOW: '#f5ba0a'
};

module.exports = Colors;


/** WEBPACK FOOTER **
 ** ./constants/Colors.js
 **/